module.exports = __webpack_public_path__ + "static/media/post06.09798972.jpg";